import Service from "./../services";
import qs from 'qs'
let workbench
let callByAli = true;
window.callByAli = callByAli;
let _initWorkbench = ({ commit, state, param, Service }) => {
    if (workbench) {
        workbench.reRender()
        return
    }
    if (callByAli) {
        workbench = new window.WorkbenchSdk({
            dom: 'ccbar',
            width: '320px',
            height: '100%',
            // instanceId: 'fd3e8c89-c1dc-42d6-84de-fa89fed48ae1',
            // instanceId: state.initialInfo.instanceId,
            instanceId: JSON.parse(localStorage.getItem('initialInfo')).instanceId,
            ajaxPath: '/api/callcenter',
            ajaxMethod: 'post',
            ajaxOtherParams: {
                userGid: state.auth.userGid
            },
            afterCallRule: 15,
            header: false,
            autoAnswerCall: 8,
            // 有来电振铃响8s后自动接听
            useOpenApiSdk: false,
            exportErrorOfApi: true,
            moreActionList: ['mobilePhoneAnswer', 'break', 'offline'],
            onInit: function() {
                // win.workbench.register() // 想实现自动上线在此注册
                workbench.register()
            },
            onBeforeCallDialing: function(payload) {
                console.log('onBeforeCallDialing----->', payload)
                if (payload.callee) {
                    // 执行callback调用 拨打电话
                    payload.callback()
                }
            },
            onErrorNotify: function(error) {
                /**
                 * 当有一些错误信息的时候触发，可以获取error信息，error参数含义如下：
                 * errorCode: 错误code,
                 * errorMsg: response错误信息,
                 * errorMsgTip: 我们定义的中文错误信息,
                 * requestId: 请求ID
                 */
                console.warn(error)
                commit('setCallInfo', {})
                commit('setCallState', -1)
            },
            onCallComing: function(callDetail) {
                /**
                 * 来电时触发，可以在该函数内获取到一个对象callDetail，callDetail参数信息含义如下：
                 * caller：主叫号码
                 * callType：呼叫类型
                 * jobId：当前通话的ID
                 * callContext：当前通话的详细信息
                 */
                console.log("onCallComing", JSON.stringify(callDetail))
                commit('setCallInfo', {...callDetail, inout: 'in', dialing: true, dialingTime: new Date().getTime() })
            },
            onCallDialing: function(callDetail) {
                /**
                 * 去电、 拨号振铃时触发， 可以在该函数内获取到一个对象callDetail， callDetail参数信息含义如下：
                 * caller： 主叫号码
                 * callee： 被叫号码
                 * callType： 呼叫类型
                 * jobId： 当前通话的ID
                 * callContext： 当前通话的详细信息
                 */
                console.log('onCallDialing', JSON.stringify(callDetail))
                commit('setCallInfo', {...callDetail, inout: 'out', dialing: true, dialingTime: new Date().getTime() })
            },
            onStatusChange: function(codeDetail) {
                const code = codeDetail.code;
                const lastCode = codeDetail.lastCode;
                const context = codeDetail.context;
                console.log(code, lastCode, context)
                if (code == 3 && context.workingMode == "offline") { code = 41 }
                commit('setCallState', code)
                if (!state.auth) {
                    if (code === 3 || code === 2 || code === 5) {
                        workbench.logOut()
                    } else if (code === 8 || code === 9 || code === 10 || code === 21) {
                        workbench.hangUp()
                    }
                } else if (lastCode === 5 && code === 2) {
                    // 如果是话后处理结束，会变成小休，此时直接变成空闲状态
                    workbench.ready()
                } else if (lastCode === 6 && code === 9) {
                    console.log("接听电话");

                }
            },
            onCallEstablish: function(callDetail) {
                /**
                 * 通话建立连接时触发，可以在该函数内获取到一个对象callDetail，callDetail参数信息含义如下：
                 * callContext：当前通话的详细信息
                 */
                console.log('这里是通话建立时触发的回调函数', JSON.stringify(callDetail))
                    // if (state.callInfo.caller === caller) {
                commit('setCallInfo', {...state.callInfo, dialing: false, speakTime: new Date().getTime() });
                // }
            },
            onCallRelease: function(callDetail) {
                /**
                 * 通话结束时触发，可以在该函数内获取到一个对象callDetail，callDetail参数信息含义如下：
                 * callContext：当前通话的详细信息
                 */
                console.log('这里是通话结束时触发的回调函数', callDetail.callContext)
                let param = {
                    CalledNumber: state.callInfo.callee,
                    CallingNumber: state.callInfo.caller,
                    ContactType: state.callInfo.inout === 'in' ? 'Inbound' : (state.callInfo.inout === 'out' ? 'Outbound' : 'Internal'),
                    UserGid: state.callInfo.personGid, //关联老人
                    CallId: state.callInfo.jobId,
                    ContactId: state.callInfo.jobId,
                    StartTime: state.callInfo.dialingTime,
                    SpeakBegin: state.callInfo.speakTime,
                    StopTime: new Date().getTime()
                }
                Service.callApiService('CallRecords/hangUp', 'POST', qs.stringify(param), null, null, null, 'application/x-www-form-urlencoded').then(res => {
                    commit('setCallReason', "");
                })
                commit('setCallInfo', {})
            },
            onHangUp: function(type) {
                console.log('这里是onHangUp事件，type =' + type)
            }
        })

    } else {
        /*
         *115097310138001 115097310138002
         *坐席工号：
         *8001@jygjjyl
         *8002@jygjjyl
         *密码：1234qwer
         */
        let host = 'http://ftykf.gsftyh.net:9060'; //云呼平台接入地址，由云呼平台提供
        let entId = '1013'; //企业ID，由云呼平台提供
        let loginKey = 'YK9EYKT53DNR2JKE4FHPXKEF9U211P0Y'; //登录密钥，32位长度，由云呼平台提供
        let productId = '003'; //企业订购的产品，由云呼平台提供
        let type = ''; //为空或者true时为默认基础功能界面,advanced为带更多功能的界面,false时只进行初始化,界面自行开发
        /*初始化*/
        $(function() {
            // 进行ccbar初始化,必填参数为云呼平台接入地址,企业ID，由云呼平台提供,登录密钥,订购产品,可选参数为是否需要ccbar默认界面,默认为true
            // false表示不使用默认的界面,
            // 需要自己实现,
            // 实现方式参见demo和代码说明
            ccbarsdk.init(host, entId, productId, loginKey, function() {
                ccbar_plugin.init('', '', type);
            });
            ccbarsdk.registMessageListener('logon', handleLogon); //签入
            ccbarsdk.registMessageListener('logoff', handleLogoff); //签出
            ccbarsdk.registMessageListener('evtAltering', handleAltering); //呼出振铃
            ccbarsdk.registMessageListener('evtConnected', handleMessage); //来电弹屏
            // ccbarsdk.registMessageListener('evtConnected', handleMessage); //接通事件
            ccbarsdk.registMessageListener('evtDisConnected', handleClearcall); //通话结束
            ccbarsdk.registMessageListener('agentStateSync', handleAgentStateSync);
            // ccbarsdk.makecall(called, caller, callback); //外呼 被叫号码和外显号码,外显号码通过CallControl.callerList获取,如caller传''则外呼时自动取坐席对应的外显号码
            CallControl.callerList(function(result) { console.log("callerList" + JSON.stringify(result)) });

            //   onBeforeCallDialing: function(payload) {
            //     console.log('onBeforeCallDialing----->', payload)
            //     if (payload.callee) {
            //         // 执行callback调用 拨打电话
            //         payload.callback()
            //     }
            // },


        });
        //处理振铃
        function handleAltering(result) {
            console.log("handleAltering::" + JSON.stringify(result));
            commit('setCallInfo', {
                caller: result.event.caller,
                callee: result.event.called,
                inout: 'out',
                dialing: true
            });
        }
        //来电弹屏//处理接通事件
        function handleMessage(result) {
            console.log('来电弹屏-------')
            commit('setCallInfo', {
                caller: result.event.caller,
                callee: result.event.called,
                inout: 'in',
                dialing: false
            })
        }
        //处理签入
        function handleLogon(result) {
            console.log('处理签入' + JSON.stringify(result));
            // CallControl.autoAnswer(true, function(result) { console.log(result) });
            CallControl.workMode('inbound', function(result) { console.log(result) }) //inbound呼入,outbound呼出
            CallControl.wakeupSIP();

            // window.location = "yunqumicrosip://3F85BCCF77A2FB712FB20688B0CAE8009F2B9D5AAECC0AE64DA12F772AE8F4F15E5B394F5E151754F002FD55039F12882F437AB9C28AA1F7648689A5DB2951684C79060FA016955E0FEEBFCD25EA2E630592DBAD77E2ED3B";
        }

        window.jsonpCallbackBeforeLogin = function(result) {
                console.log("jsonpCallbackBeforeLogin::" + JSON.stringify(result));
            }
            //处理签出
        function handleLogoff(result) {
            console.log('处理签出' + JSON.stringify(result))
        }
        //处理挂机
        function handleClearcall(result) {
            console.log('通话结束:' + JSON.stringify(result))
            commit('setCallInfo', {})
        }
        //坐席状态同步事件
        function handleAgentStateSync(result) {
            commit('setCallState', CallControl.getState());
            console.log("坐席状态同步事件" + CallControl.getState());
            // if (CallControl.getState() == "ALERTING") {
            //     console.log('通话建立')
            //         // if (state.callInfo.caller === caller) {
            //     commit('setCallInfo', {...state.callInfo, dialing: false });
            //     // }
            // }
        }
    }

    window.workbench = workbench
}

export function initWorkbench({ commit, state, param }) {
    _initWorkbench({ commit, state, param, Service, qs });

}